<template>
	<CCard>
		<CCardHeader>
			<h5>User Profile</h5>
		</CCardHeader>
		<CCardBody :style="{ position: 'relative', top: '-18px' }" class="p-5">
			<!-- <CRow>
				<CCol sm="6" style="padding: 20px 40px"> -->
			<CRow>
				<CCol sm="6">Name</CCol>
				<CCol sm="6">{{ userDetails.name }}</CCol>
			</CRow>
			<CRow>
				<CCol>Mail</CCol>
				<CCol>{{ userDetails.email }}</CCol>
			</CRow>
			<CRow>
				<CCol>Created On</CCol>
				<CCol>{{ getDate }}</CCol>
			</CRow>
			<!-- </CCol>
				<CCol sm="6" style="padding: 20px 40px"> -->
			<CRow>
				<CCol sm="6">Client / Hospital Name</CCol>
				<CCol sm="6">{{ userDetails.client.name }}</CCol>
			</CRow>
			<CRow>
				<CCol>Role</CCol>
				<CCol
					><CBadge color="primary" style="font-size: 12px">{{
						getRoleName
					}}</CBadge></CCol
				>
			</CRow>
			<!-- </CCol>
			</CRow> -->
		</CCardBody>
		<CCardFooter>
			<CButton color="warning" @click="$router.push('reset-password')"
				>Reset Password</CButton
			>
		</CCardFooter>
	</CCard>
</template>

<script>
import { storeData } from "../../store";
export default {
	data() {
		return {
			userDetails: { ...storeData.currentUserDetails },
		};
	},
	computed: {
		getRoleName() {
			if (this.userDetails.role.name === "sys_admin") return "System Admin";
			else if (this.userDetails.role.name === "client_admin")
				return "Client Admin";
			else if (this.userDetails.role.name === "client_user")
				return "Client User";
			else if (this.userDetails.role.name === "group_admin")
				return "Group Admin";
		},
		getDate() {
			let date = new Date(this.userDetails.added);
			return date.toDateString() + " " + date.toLocaleTimeString();
		},
	},
	beforeMount() {
		console.log(this.userDetails);
	},
};
</script>
